import {
  sortProducts,
  countProducts,
  findProductIndexInProducts,
  groupProductsByStore
} from "../../utils";

const parseCartFromJSON = () => {
  try {
    return JSON.parse(localStorage.getItem("cart")) || { products: [] };
  } catch (e) {
    return { products: [] };
  }
};

const state = {
  cart: parseCartFromJSON()
};

const getters = {
  getCart: state => state.cart,

  getProductsInCart: state => state.cart.products,

  getProductsGroupedByStore: state => groupProductsByStore(state.cart.products),

  getCountedSortedProducts: state =>
    sortProducts(countProducts(state.cart.products), FIELD_SORTING),
  getCountedProducts: state => countProducts(state.cart.products),
  isProductInCart: state => product =>
    getters.findProductIndexInCart(state)(product) > -1,

  findProductIndexInCart: state => product =>
    findProductIndexInProducts(product, state.cart.products, UNIQUE_FIELDS)
};

const actions = {
  updateCart() {
    localStorage.setItem("cart", JSON.stringify(state.cart));
  }
};

const mutations = {
  setCart(state, cart) {
    state.cart = cart;
    actions.updateCart();
  },

  addProductToCart(state, product) {
    state.cart.products = [...state.cart.products, product];
    actions.updateCart();
  },
  removeProductFromCart(state, product) {
    const index = getters.findProductIndexInCart(state)(product);
    if (index !== -1) {
      state.cart.products.splice(index, 1);
      actions.updateCart();
    }
  }
};

export const UNIQUE_FIELDS = ["_id", "chosenSize", "color"];
export const FIELD_SORTING = {
  name: (a, b) => (a < b ? -1 : a > b ? 1 : 0),
  chosenSize: (a, b) => {
    const size_order = ["XS", "S", "M", "L", "XL"];
    const sizeToIndex = size => size_order.indexOf(size);
    return sizeToIndex(a) < sizeToIndex(b)
      ? -1
      : sizeToIndex(a) > sizeToIndex(b)
      ? 1
      : 0;
  },
  color: (a, b) => (a < b ? -1 : a > b ? 1 : 0)
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
